import { render, staticRenderFns } from "./FormTaxPph23Code.vue?vue&type=template&id=a6cbd5ae"
import script from "./FormTaxPph23Code.vue?vue&type=script&lang=js"
export * from "./FormTaxPph23Code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports